import { doLogout } from '@/actions/auth'
import { useAppDispatch } from '@/hooks'
import useMockableViewModel from '@/hooks/useMockableViewModel'

function useViewModel() {
  const dispatch = useAppDispatch()

  const handleLogout = () => {
    doLogout(dispatch)
    window.location.reload()
  }

  return {
    handleLogout,
  }
}

function useMockViewModel() {
  return {
    handleLogout: () => alert('Logged out'),
  }
}

export default useMockableViewModel({ useViewModel, useMockViewModel })
